import moment from "moment";
import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postRoyalMailForm } from "../../redux/actions/royalMailActions";

const AdditionalSecurityForm = ({ appData, postRoyalMailFormFunc }) => {
  const {
    title = "",
    firstName = "",
    lastName = "",
    dateOfBirth = moment(),
    nationalInsuranceNo = "",
    address: {
      addressLine1 = "",
      addressLine2 = "",
      addressLine3 = "",
      town = "",
      postcode = "",
      country = "",
    },
  } = appData;

  let initialData = {
    title,
    firstname: firstName,
    lastname: lastName,
    dateofbirth: moment(dateOfBirth).format("DD/MM/YYYY"),
    nin: nationalInsuranceNo,
    address11: addressLine1,
    address12: [addressLine2, addressLine3].filter((f) => f).join(", "),
    posttown1: town,
    postcode1: postcode,
    country1: country,

    signed: `${firstName} ${lastName}`,
    dateSigned: moment().format("DD/MM/YYYY"),
  };

  if (appData.royalMailOnboarding && appData.royalMailOnboarding.addSF) {
    initialData = {
      ...initialData,
      ...appData.royalMailOnboarding.addSF,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const validateDDMMYYYY = (value) => {
    if (!value) return true;
    const date = moment(value, "DD/MM/YYYY", true);
    return date.isValid();
  };

  const initialState = {
    box1start: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Individual Personal Data and Declaration"} />
        </div>
      ),
    },
    title: { title: "Title:", value: getVal("title"), mandatory: true },
    firstname: {
      title: "First Name:",
      value: getVal("firstname"),
      mandatory: true,
    },
    lastname: { title: "Surname:", value: getVal("lastname"), mandatory: true },
    middlename: { title: "Middle Name(s):", value: getVal("middlename") },
    prevsurname: {
      title: "Previous Surname(s):",
      value: getVal("prevsurname"),
    },
    prevforename: {
      title: "Previous Forename(s):",
      value: getVal("prevforename"),
    },
    dateofbirth: {
      title: "Date Of Birth:",
      value: getVal("dateofbirth"),
      mandatory: true,
      validate: validateDDMMYYYY,
    },
    nin: {
      title: "NI Number:",
      value: getVal("nin"),
      mandatory: true,
    },
    delimiter: { htmlObj: <HorizontalLine text={"Current UK Address"} /> },
    address11: {
      title: "Address Line 1:",
      value: getVal("address11"),
      mandatory: true,
    },
    address12: {
      title: "Address Line 2:",
      value: getVal("address12"),
    },
    posttown1: {
      title: "Post Town:",
      value: getVal("posttown1"),
      mandatory: true,
    },
    postcode1: {
      title: "Postcode:",
      value: getVal("postcode1"),
      mandatory: true,
    },
    country1: {
      title: "Country:",
      value: getVal("country1"),
      mandatory: true,
    },
    resident1: {
      title: "Resident at this address from:(dd/mm/yyyy):",
      value: getVal("resident1"),
      mandatory: true,
      validate: validateDDMMYYYY,
    },
    delimiter2: {
      htmlObj: (
        <HorizontalLine
          text={
            "Previous Address: (If period of residence at current address is LESS than 5 YEARS)"
          }
        />
      ),
    },
    address21: {
      title: "Address Line 1:",
      value: getVal("address21"),
    },
    address22: {
      title: "Address Line 2:",
      value: getVal("address22"),
    },
    posttown2: {
      title: "Post Town:",
      value: getVal("posttown2"),
    },
    postcode2: {
      title: "Postcode:",
      value: getVal("postcode2"),
    },
    country2: {
      title: "Country:",
      value: getVal("country2"),
    },
    resident2: {
      title: "Resident at this address from:(dd/mm/yyyy)",
      value: getVal("resident2"),
      validate: validateDDMMYYYY,
    },
    delimiter3: {
      htmlObj: (
        <div>
          <p>
            I give consent for Royal Mail Group to carry out the following
            checks:
          </p>
          <HorizontalLine
            desc="1: Voters & Credit Check: a) Bankruptcy b) Individual Voluntary
          Arrangement c) County Court Judgment(s) (Cat 1a & 1b, 4 & 7 only)"
          />
          <HorizontalLine
            desc="2: Sanctions Check: - Specialised searches that covers a number of
          US and EU government sanction databases as well as HM Treasury
          Databases to identify individuals who are prohibited from certain
          activities or industries (Cat 4 Only)"
          />
          <HorizontalLine
            desc="3: Counter Terrorism Check (CTC) - A check is carried out by RMG Security
            Intelligence Team for candidates applying to work in a Mail Screening role. (Cat 2 only)
            Royal Mail Group will use this information to assess individual suitability for employment
            in line with Royal Mail Group Vetting Policy and industry standards as applicable to this 
            role and the information may be shared within Royal mail Group. Please note: A record of 
            the search will be retained by the credit reference agencies and may be supplied by them to 
            other organizations if for example you apply for credit in the future."
          />
          <HorizontalLine
            desc="4: Conflict of Interest Check (COI) (Cat 1a, 1b & 4 only)
            Royal Mail Group will perform searches of Companies House and any other checks or 
            searches that are deemed necessary and reasonable during my period of employment 
            with Royal Mail Group."
          />
          <HorizontalLine
            desc="I understand that by giving my consent below. Royal Mail Group has permission to carry 
            out the above check(s) and for those to be audited by a third party that is approved by Royal Mail Group."
          />
        </div>
      ),
    },
    signed: {
      title: "Signed:",
      value: getVal("signed"),
      mandatory: true,
    },
    date: {
      title: "Date:(dd/mm/yyyy)",
      value: moment().format("DD/MM/YYYY"),
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postRoyalMailFormFunc("addSF", {
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/royal-mail-onboarding");
  };

  return (
    <FormCreator
      formTitle={"Additional Security Checks Consent Form"}
      description={
        "Please note; this form is only to be used for new applicants or existing Royal Mail Group employees who undertake a role where these checks are mandatory under the terms of the Royal Mail Vetting Policy."
      }
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
    />
  );
};
AdditionalSecurityForm.propTypes = {
  appData: any,
  postRoyalMailFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postRoyalMailFormFunc: postRoyalMailForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(AdditionalSecurityForm);
